var _excluded = ["closeOnSelect", "closeOnBlur", "defaultIsOpen", "onClose", "onOpen", "palette"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { usePopper } from "../popper";
import { useMenuItems } from "./useMenuItems";
export var useMenu = function useMenu(props) {
  var _props$closeOnSelect = props.closeOnSelect,
      closeOnSelect = _props$closeOnSelect === void 0 ? true : _props$closeOnSelect,
      _props$closeOnBlur = props.closeOnBlur,
      closeOnBlur = _props$closeOnBlur === void 0 ? true : _props$closeOnBlur,
      defaultIsOpen = props.defaultIsOpen,
      onCloseProp = props.onClose,
      onOpenProp = props.onOpen,
      _props$palette = props.palette,
      palette = _props$palette === void 0 ? 'light' : _props$palette,
      popperProps = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(defaultIsOpen || false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var _React$useState3 = React.useState(-1),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      focusedIndex = _React$useState4[0],
      setFocusedIndex = _React$useState4[1];

  var _useMenuItems = useMenuItems(),
      register = _useMenuItems.register,
      unregister = _useMenuItems.unregister,
      menuItems = _useMenuItems.menuItems;

  var menuRef = React.useRef(null);
  var buttonRef = React.useRef(null);
  var onClose = React.useCallback(function () {
    setIsOpen(false);
    onCloseProp === null || onCloseProp === void 0 ? void 0 : onCloseProp();
  }, [onCloseProp]);
  var onOpen = React.useCallback(function () {
    setIsOpen(true);
    onOpenProp === null || onOpenProp === void 0 ? void 0 : onOpenProp();
  }, [onOpenProp]);
  var onToggle = React.useCallback(function () {
    var action = isOpen ? onClose : onOpen;
    action();
  }, [isOpen, onOpen, onClose]);
  useOutsideClick({
    ref: menuRef,
    callback: function callback(event) {
      var _buttonRef$current;

      if (isOpen && closeOnBlur && !((_buttonRef$current = buttonRef.current) !== null && _buttonRef$current !== void 0 && _buttonRef$current.contains(event.target))) {
        onClose();
      }
    }
  });
  var openAndFocusFirstItem = React.useCallback(function () {
    onOpen();
    var firstEnabledItemIndex = menuItems.findIndex(function (menuItem) {
      return !menuItem.disabled;
    });
    if (firstEnabledItemIndex !== -1) setFocusedIndex(firstEnabledItemIndex);
  }, [onOpen, setFocusedIndex, menuItems]);
  var popper = usePopper(popperProps);
  return {
    popper: popper,
    isOpen: isOpen,
    onToggle: onToggle,
    onOpen: onOpen,
    onClose: onClose,
    openAndFocusFirstItem: openAndFocusFirstItem,
    menuRef: menuRef,
    buttonRef: buttonRef,
    closeOnSelect: closeOnSelect,
    closeOnBlur: closeOnBlur,
    focusedIndex: focusedIndex,
    setFocusedIndex: setFocusedIndex,
    menuItems: menuItems,
    register: register,
    unregister: unregister,
    palette: palette
  };
};